module.exports = __webpack_public_path__ + "static/media/Twemoji12.1.3 1f3f5.936f7125.svg";